export default __webpack_public_path__ + "static/media/quanto.b2bd72fe.png";